import { render, staticRenderFns } from "./FormReview.vue?vue&type=template&id=1983270a&"
import script from "./FormReview.vue?vue&type=script&lang=js&"
export * from "./FormReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports